import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useUploadTripLogListExcel = () => {
    const modalContext = useContext(ModalContext);
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onUploadTripLogListExcelError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while uploading trip log list.',
        );
    };

    const onUploadTripLogListExcelSuccess = (resetForm: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Trip log list uploaded successfully.');
        modalContext?.setShowSuccessComponent(true);
        resetForm();
    };

    const uploadTripLogListExcel = (data: any, resetForm: () => void) => {
        const formData = new FormData();

        if (data?.excelFile?.length > 0 && data.excelFile[0] instanceof File) {
            formData.append('file', data.excelFile[0], data.excelFile[0].name);
        } else {
            console.warn('No valid excelFile provided');
        }

        const url: HttpConfig = {
            url: 'api/v1/trip-logs/upload-excel',
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        request(url, onUploadTripLogListExcelSuccess(resetForm), setLoading, onUploadTripLogListExcelError);
    };

    return { uploadTripLogListExcel, loading };
};

export default useUploadTripLogListExcel;
